module.exports = __webpack_public_path__ + "static/media/ad-06.5c375913.jpg";